import { Component, OnInit, ElementRef, ViewChild } from '@angular/core'
import { Router } from '@angular/router'
import { ActivatedRoute, Params } from '@angular/router'
import { EappBeneficiaryGateway } from '../gateways/EAppEnrollment-gateway'
import { BeneficiaryInfoBeneficiary } from '../models/enrollments-beneficiary'
import { EappUpdateStatusBeneficiary } from '../models/eapp-beneficiary-status-model'
import { UserProfile } from '../models/user-profile'
import { EnrollmentViewModel } from '../models/enrollment-view-model'
import * as moment from 'moment'
import { VerifyBeneficiary } from '../models/verify-beneficiary'

@Component({
    selector: 'EAppBeneEnrollmentReadonly',
    templateUrl: 'e-app-verify.component.html',
    styleUrls: ['./EApp-beneficiary.component.scss']
})
export class EAppVerifyComponent implements OnInit {
    verifyEAP: any = {
        medicareNumber: '',
        firstName: '',
        lastName: '',
        DOB: null
    } as any
    userName: string = ''
    medicareNumber: string = ''
    lastName: string = ''
    DOB: Date | null = null
    counter: number = 0
    disabled: boolean = false
    // notBlankValidator = new NotBlankGenericFieldValidator()
    // validatedDate = new DateTextFieldValidator()
    private uniqueLink: string
    enrollmentViewModel: EnrollmentViewModel = {} as EnrollmentViewModel
    enrollment: BeneficiaryInfoBeneficiary = {} as BeneficiaryInfoBeneficiary
    isValid: boolean = true
    showPage: boolean = false
    ErrorMessages: any[]
    eappUpdateStatusModel: EappUpdateStatusBeneficiary = {} as EappUpdateStatusBeneficiary
    agentId: number
    userProfileModel: UserProfile
    linkExpired: boolean
    appStatus: string
    showUpdatesSettingsMessage = 'Success'
    LinkExpired: boolean
    ApplicationStatus: string
    FormCompleted: boolean
    showText: boolean = false
    showExpiredMsg: boolean = false
    public loading: boolean = false
    public insurance: string
    @ViewChild('focusableEleTop', { static: true }) focusableEleTop: ElementRef
    TestData: string

    constructor(private _router: Router, private route: ActivatedRoute, private _enrollmentGateway: EappBeneficiaryGateway) {
        this.userProfileModel = {} as UserProfile
        //this.getParams();
        //this._enrollmentGateway.getEappDetails(this.uniqueLink).subscribe(
        //    (model: any) => {
        //        this.TestData = model.ApplicationStatus
        //    })
    }

    ngOnInit() {
        //this.insurance = this._global.currentUser.insuranceCompanyName
        this.getParams()
        console.log('Load the page' + this.getParams)

        this._enrollmentGateway.getEappDetails(this.uniqueLink).subscribe((model: any) => {
            console.log('Model data: ' + model)
            if (model !== undefined) {
                this.LinkExpired = model.LinkExpired
                this.ApplicationStatus = model.ApplicationStatus
                this.FormCompleted = model.FormCompleted
                console.log('Load the GetEpDetails ' + model.ApplicationStatus)
                if (!this.validate()) {
                    this.showText = true
                    this.showExpiredMsg = false
                    this.showPage = false
                } else {
                    this.showText = false
                    this.showPage = true
                }
            }
            //this._enrollmentGateway.getEnrollmentAppDetails(this.uniqueLink).subscribe(
            //    (model: EnrollmentFieldBeneficiary[]) => {
            //        console.log("Load the GetEnrollmentDetails " + model)
            //        for (let i = 0; i < model.length; i++) {
            //            if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.APPFN) {
            //                this.enrollment.firstName = model[i].FieldValue
            //            }
            //            if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.APPLN) {
            //                this.enrollment.lastName = model[i].FieldValue
            //            }
            //            if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.HICN) {
            //                this.enrollment.medicareId = model[i].FieldValue
            //            }
            //            if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.APPDOB) {
            //                this.enrollment.dateOfBirth = new Date(model[i].FieldValue)
            //            }
            //            if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.AGENTID) {
            //                this.agentId = Number(model[i].FieldValue)
            //            }
            //            this.userName = this.enrollment.firstName + " " + this.enrollment.lastName
            //        }
            //        if (!this.validate()) {
            //            this.showText = true
            //            this.showExpiredMsg = false
            //            this.showPage = false
            //        }
            //        else {
            //            this.showText = false
            //            this.showPage = true
            //        }
            //    }
            //)
        })
    }

    validate(): boolean {
        this.isValid = true
        if (this.LinkExpired == true) {
            this.isValid = false
            this.focusableEleTop.nativeElement.focus()
        }
        if (this.ApplicationStatus == 'Correction') {
            this.isValid = false
            this.focusableEleTop.nativeElement.focus()
        }
        if (this.FormCompleted == true) {
            this.isValid = false
            this.focusableEleTop.nativeElement.focus()
        }
        if (this.ApplicationStatus == 'Failed') {
            this.isValid = false
            this.focusableEleTop.nativeElement.focus()
        }
        if (this.ApplicationStatus == 'Signed') {
            this.isValid = false
            this.focusableEleTop.nativeElement.focus()
        }
        return this.isValid
    }

    updateInfo(fieldName: string, fieldValue: Date) {
        this.DOB = fieldValue
    }
    updateInfoMediacare(fieldName: string, fieldValue: string) {
        this.medicareNumber = fieldValue.toUpperCase()
    }

    verify() {
        let beneficiaryInfo = new VerifyBeneficiary()
        beneficiaryInfo.uniqueLink = this.uniqueLink
        beneficiaryInfo.medicareNumber = this.medicareNumber
        beneficiaryInfo.lastName = this.lastName
        beneficiaryInfo.dateofBirth = moment(this.DOB, 'MM/DD/YYYY', true).format('MM/DD/YYYY')
        this.ErrorMessages = []
        this.loading = true
        this._enrollmentGateway.verifyBeneficiary(beneficiaryInfo).subscribe(
            (data: EappUpdateStatusBeneficiary) => {
                this.loading = false
                if (data.Errors.length > 0) {
                    if (data.PasswordCount > 3) {
                        this.showUpdatesSettingsMessage = 'Success'
                        this.showPage = false
                        this.showText = true
                        this.showExpiredMsg = true
                    } else {
                        data.Errors.forEach((error) => {
                            this.ErrorMessages.push(error)
                        })
                        this.isValid = false
                        this.focusableEleTop.nativeElement.focus()
                    }
                } else {
                    this.enrollmentViewModel.UNIQUELINK = this.uniqueLink
                    this._enrollmentGateway.setEnrollmentViewModel(this.enrollmentViewModel)
                    this._router.navigate(['/Step2/' + this.uniqueLink]) //call new disabled verify page
                }
            },
            (error) => {
                this.ErrorMessages.push('Could not Validate Submission. Please try after sometime')
                this.isValid = false
                this.focusableEleTop.nativeElement.focus()
                this.loading = false
            }
        )
        /*
        let dob1 = moment(this.DOB, 'MM/DD/YYYY', true).format('MM/DD/YYYY')
        let dob2 = moment(this.enrollment.dateOfBirth, 'MM/DD/YYYY', true).format('MM/DD/YYYY')
        if (this.IsDataVerify(dob1, dob2)) {
            this.eappUpdateStatusModel.ApplicationStatus = "Viewed"
            this.eappUpdateStatusModel.UniqueLink = this.uniqueLink
            this.eappUpdateStatusModel.LinkExpired = false
            this.eappUpdateStatusModel.LinkViewed = true
            this.eappUpdateStatusModel.Reason = null
            this.eappUpdateStatusModel.PasswordCount = 0
            this.loading = true
            this._enrollmentGateway.updateEAppStatus(this.eappUpdateStatusModel)
                .subscribe((model: any) => {
                    let response = model
                    if (response !== undefined) {
                        this.loading = false
                        this.enrollmentViewModel.UNIQUELINK = this.uniqueLink
                        this._enrollmentGateway.setEnrollmentViewModel(this.enrollmentViewModel)
                        this._router.navigate(['/Step2/' + this.uniqueLink])//call new disabled verify page
                    }
                    this.loading = false
                }, (err) => {
                    this.loading = false
                })
        }
        else {
            this.counter++
            if (this.counter >= 3) {
                console.log('Three tries exceeded.')
                this.eappUpdateStatusModel.ApplicationStatus = "Failed"
                this.eappUpdateStatusModel.UniqueLink = this.uniqueLink
                this.eappUpdateStatusModel.LinkExpired = false
                this.eappUpdateStatusModel.LinkViewed = true
                this.eappUpdateStatusModel.PasswordCount = 3
                this.eappUpdateStatusModel.Reason = "Identity could not be confirmed"
                this.loading = true
                this._enrollmentGateway.updateEAppStatus(this.eappUpdateStatusModel)
                    .subscribe((model: any) => {
                        let response = model
                        if (response !== undefined) {
                            this.showUpdatesSettingsMessage = 'Success'
                            this.showPage = false
                            this.showText = true
                            this.showExpiredMsg = true
                            this.loading = false

                            //this._enrollmentGateway
                            //    .notifyeAppAgent(this.agentId, this.enrollment.firstName, this.enrollment.lastName, this.eappUpdateStatusModel.ApplicationStatus)
                            //    .subscribe(() => {
                            //        this.showUpdatesSettingsMessage = 'Success'
                            //        this.showPage = false
                            //        this.showText = true
                            //        this.loading = false
                            //    })
                            //this._enrollmentGateway.findUserProfileByProfileID(this.agentId).subscribe(
                            //    (model: UserProfile) => {
                            //        this.userProfileModel = model
                            //        if (this.userProfileModel.Email !== null && this.userProfileModel.Email !== undefined) {
                            //            //this._enrollmentGateway.SendAgentEmail(this.userProfileModel.Email, '', this.userProfileModel.FirstName + '' + this.userProfileModel.LastName, this.enrollment.firstName).subscribe(() => this.showUpdatesSettingsMessage = 'Success')
                            //            this._enrollmentGateway
                            //                .SendAgentEmail(this.userProfileModel.Email,
                            //                                '',
                            //                this.userProfileModel.FirstName,
                            //                this.userProfileModel.LastName,
                            //                this.enrollment.firstName,
                            //                this.enrollment.lastName)
                            //                .subscribe(() => this.showUpdatesSettingsMessage = 'Success')
                            //            this.showPage = false
                            //            this.showText = true
                            //            this.loading = false
                            //        }
                            //        this.loading = false
                            //    }, (err) => {
                            //        this.loading = false
                            //    })
                            //this.loading = false
                        }
                        this.loading = false
                    }, (err) => {
                        this.loading = false
                    })
            }
        }
        */
    }

    IsDataVerify(dob1: string, dob2: string): boolean {
        this.ErrorMessages = [] as any[]
        this.isValid = true
        if (this.medicareNumber.toUpperCase() !== this.enrollment.medicareId.toUpperCase()) {
            this.ErrorMessages.push('Please enter a valid Medicare Number, using only numbers and letters. Do not include hyphens.')
            this.isValid = false
            this.focusableEleTop.nativeElement.focus()
        }
        if (this.lastName.toUpperCase() !== this.enrollment.lastName.toUpperCase()) {
            this.ErrorMessages.push('Please enter a valid Last Name')
            this.isValid = false
            this.focusableEleTop.nativeElement.focus()
        }
        if (dob1 !== dob2) {
            this.ErrorMessages.push('Please enter a valid Date of Birth')
            this.isValid = false
            this.focusableEleTop.nativeElement.focus()
        }
        return this.isValid
    }

    getParams() {
        this.route.params.forEach((params: Params) => {
            this.uniqueLink = this.route.snapshot.params['guid']
        })
    }
    onKeyDown(event) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            this.verify()
        }
    }
}
